<section class="favie-page-layout">
  <div class="page-layout-header">
    <div class="page-layout-header-content">
      <div class="page-layout-header-title">
        <ng-content select="[title]"></ng-content>
      </div>

      <div class="spacing"></div>

      <div class="page-layout-header-action">
        <ng-content select="[action]"></ng-content>
      </div>
    </div>
  </div>

  <div class="page-layout-content">
    <ng-content select="[content]"></ng-content>
  </div>
  <div class="page-layout-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</section>